module.exports = __webpack_public_path__ + "static/media/icons-add-24.75b16362.svg";